import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { addDays, format, parseISO } from 'date-fns';
import { queryReimburse, queryCate, submitReimburse as _submitReimburse, withdrawReimburse as _withdrawReimburse, delReimburse as _delReimburse } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '报销编号',
      dataIndex: 'id',
      align: 'center',
      width: 100
    }, {
      title: '报销名称',
      dataIndex: 'fillName',
      align: 'center',
      ellipsis: true,
      width: 150
    }, {
      title: '报销金额',
      dataIndex: 'totalAmount',
      align: 'center',
      width: 90
    }, {
      title: '申请人',
      dataIndex: 'userName',
      align: 'center',
      width: 120,
      ellipsis: true,
      customRender: function customRender(userName, row) {
        return userName + ' (' + row.organName + '/' + row.postName + ')';
      }
    }, {
      title: '申请时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '报销状态',
      dataIndex: 'reimburseStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'reimburseStatus'
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      expand: false,
      cateList: [],
      where: {
        reimburseStatus: undefined,
        cateId: undefined,
        startDate: '',
        endDate: '',
        startAndEndDate: [],
        query: ''
      },
      data: [],
      pagination: this.$hdk.page(),
      visibleMode: false
    };
  },
  created: function created() {
    var _this = this;
    var fetch = this.fetch;
    fetch();
    // 查询报销分类
    queryCate().then(function (res) {
      _this.cateList = res.data.data;
    });
  },
  methods: {
    /**
     * 根据条件搜索
     */
    fetch: function fetch(options) {
      var _this2 = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }

      // 日期格式化
      if (where.startAndEndDate.length > 0) {
        this.where.startDate = parseISO(format(where.startAndEndDate[0]._d, 'yyyy-MM-dd'));
        this.where.endDate = parseISO(format(where.startAndEndDate[1]._d, 'yyyy-MM-dd'));
      } else {
        this.where.startDate = null;
        this.where.endDate = null;
      }
      queryReimburse(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this2.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /**
     * 提交报销申请
     */
    submitReimburse: function submitReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认提交吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _submitReimburse(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('提交成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /**
     * 删除报销申请
     */
    delReimburse: function delReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _delReimburse(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
          }
          fetch();
        });
      }).catch(function () {});
    },
    /**
     * 撤回报销申请
     */
    withdrawReimburse: function withdrawReimburse(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认撤回吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _withdrawReimburse(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('撤回成功');
          }
          fetch();
        });
      }).catch(function () {});
    },
    /**
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 新建申请单弹框
     */
    newReimburse: function newReimburse(row) {
      this.visibleMode = true;
    },
    /**
     * 选择报销单跳转
     */
    addReimburse: function addReimburse(flag) {
      if (flag === 1) {
        // 差旅费用报销单
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelSingle',
          query: {
            type: 1
          }
        });
      } else if (flag === 2) {
        // 费用报销单
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseSingle',
          query: {
            type: 1
          }
        });
      }
    },
    /**
     * 编辑报销
     */
    editReimburse: function editReimburse(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelSingle',
          query: {
            fillId: row.id,
            type: 2
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseSingle',
          query: {
            fillId: row.id,
            type: 2
          }
        });
      }
    },
    /*
     * 查看
     */
    viewReimburse: function viewReimburse(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelApproval',
          query: {
            fillId: row.id,
            type: 3
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.id,
            type: 3
          }
        });
      }
    }
  }
};